var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMap = function SvgIconMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    fill: "none",
    viewBox: "0 0 14 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20Q0 10.865 0 7a7 7 0 0 1 14 0q0 3.865-7 13m0-9a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })));
};
export default SvgIconMap;